import { render } from "./UserServices.vue?vue&type=template&id=118ae620"
import script from "./UserServices.vue?vue&type=script&lang=js"
export * from "./UserServices.vue?vue&type=script&lang=js"

import "./UserServices.vue?vue&type=style&index=0&id=118ae620&lang=css"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__